var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productPage"},[_c('div',{staticClass:"head"},[_c('NavBar'),_c('div',{class:[{ hide: _vm.hideMenu }, 'collapse']},[_c('Menu')],1)],1),_c('div',{class:[{ hasFilters: _vm.showFilters }, 'productPageContent']},[_c('router-view')],1),_vm._m(0),_c('ProductModal'),_c('DialogAlcohol')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_menu"},[_c('div')])
}]

export { render, staticRenderFns }